import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/router/routes/index';
import stores from '@/store/core/RootStore';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!stores.userStore.isLoggedIn && to.path !== '/auth')
    next({ path: '/auth' });
  else next();
});

export default router;
